import React, { useState } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from '../../common/react-redux-hooks';
import CacGridData from '../CacGridData';
import * as cacActions from '../../../actions/cacActions';
import PortalModal from '../../common/Modal/PortalModal';
import GenericButton from '../../common/GenericButton';
import { INSUFFICIENT_DATA_MODAL_TEXT, CAC_MODULE_TITLE, ADD_TO_PASSIVE_EVENT,
  SHOW_HIDE_DATAPOINT_EVENT } from '../CacConstants';
import CacSwitchPanel from '../CacSwitchPanel';
import CorrAxisSelectBlock from './CorrAxisSelectBlock';
import CorrModelPerfBlock from './CorrModelPerfBlock';
import { getApiRequestParameter } from '../../../util/cacUtils';

function CorrLeftContentGrid(props) {
  const minRequireModalStyle = {
    width: '560px',
    left: 'calc(50vw - 280px)',
    top: '30%',
  };
  const [minReqiureModal, setMinReqiureModal] = useState(props.minReqiureModal);
  const { projectId, corrMapView, chartView, corrResponse } = props.project;
  const { userId, currentAccountId } = useSelector(state => state.login.loginResponse.data);

  const dispatch = useDispatch();
  const toggleCollapsibleDropdown = (keyType, activeProjectId) => {
    dispatch(cacActions.toggleCollapsibleDropdown(keyType, activeProjectId));
  };
  const setChartView = chartView => {
    dispatch(cacActions.setCacChartView(projectId, chartView));
    // dispatch(cacActions.updateCacNodeLabelPositions(projectId, [], true));
    // dispatch(cacActions.updateCacNodeLabelPositions(projectId, [], false));
  };

  const addToPassive = (keyType, activeProjectId, index, isPassive) => {
    const gridData = keyType === 'row' ? props.project.rows : props.project.columns;
    const gridFilterData = _.filter(gridData, item => item.isShow === true);
    const passives = keyType === 'row' ? props.project.passiveRows : props.project.passiveCols;
    if (gridFilterData.length - passives.length > 3 || isPassive) {
      dispatch(cacActions.addToPassive(keyType, activeProjectId, index));
      const projectObj = getApiRequestParameter(props.project, keyType, index, ADD_TO_PASSIVE_EVENT);
      dispatch(cacActions.getCACProjectDetails({ userId, currentAccountId, ...projectObj }));
      dispatch(cacActions.getClusterProjectDetails({ userId, currentAccountId, ...projectObj }));      
      dispatch(cacActions.clearCacNodeLabelPositions(projectId));
      } else {
      setMinReqiureModal(true);
    }
  };

  const showHideDataPoint = (keyType, activeProjectId, index, isShow) => {
    const gridData = keyType === 'row' ? props.project.rows : props.project.columns;
    const gridFilterData = _.filter(gridData, item => item.isShow === true);
    const passives = keyType === 'row' ? props.project.passiveRows : props.project.passiveCols;
    if (gridFilterData.length - passives.length > 3 || isShow) {
      dispatch(cacActions.showHideDataPoint(keyType, activeProjectId, index));
      const projectObj = getApiRequestParameter(props.project, keyType, index, SHOW_HIDE_DATAPOINT_EVENT);
      dispatch(cacActions.getCACProjectDetails({ userId, currentAccountId, ...projectObj }));
      dispatch(cacActions.getClusterProjectDetails({ userId, currentAccountId, ...projectObj }));
      dispatch(cacActions.clearCacNodeLabelPositions(projectId));
    } else {
      setMinReqiureModal(true);
    }
  };

  const getVarianceValues = () => {
    return (corrResponse && corrResponse.cm)
      ? corrResponse.cm.varianceExplainedValues
      : [];
  };

  return (
    <div className="view-left-content" data-test="CorrLeftContentGridComponent">
      <CacGridData
        data-test="cacGridDataComp"
        project={props.project}
        toggleCollapsibleDropdown={toggleCollapsibleDropdown}
        addToPassive={addToPassive}
        showHideDataPoint={showHideDataPoint}
      />
      <CacSwitchPanel mapView={corrMapView} aType="corr" />
      <CorrAxisSelectBlock
        activeProjectId={projectId}
        chartView={chartView}
        setChartView={setChartView}
      />
      <CorrModelPerfBlock
        corrResponse={corrResponse}
        chartView={chartView}
        varianceExplainedValues={getVarianceValues()}
      />
      <PortalModal
        isShowing={minReqiureModal}
        hide={() => setMinReqiureModal(false)}
        title={CAC_MODULE_TITLE}
        dialogStyles={minRequireModalStyle}
        onCloseClicked={() => setMinReqiureModal(false)}
      >
        <div>{INSUFFICIENT_DATA_MODAL_TEXT.split('|')[0]}</div>
        <div style={{ paddingBottom: '15px' }}>
          {INSUFFICIENT_DATA_MODAL_TEXT.split('|')[1]}
        </div>
        <div className="text-center">
          <GenericButton
            name="Ok"
            onBtnClick={() => setMinReqiureModal(false)}
          />
        </div>
      </PortalModal>
    </div>
  );
}

CorrLeftContentGrid.defaultProps = {
  minReqiureModal: false,
};

CorrLeftContentGrid.propTypes = {
  project: PropTypes.shape({
    study: PropTypes.instanceOf(Object),
    rows: PropTypes.arrayOf(PropTypes.object),
    columns: PropTypes.arrayOf(PropTypes.object),
    base: PropTypes.arrayOf(PropTypes.object),
    isBaseOpen: PropTypes.bool,
    isRowsOpen: PropTypes.bool,
    isColumnsOpen: PropTypes.bool,
    isPassivesOpen: PropTypes.bool,
    projectId: PropTypes.number,
    corrMapView: PropTypes.bool,
    chartView: PropTypes.instanceOf(Array),
    passiveRows: PropTypes.arrayOf(PropTypes.number),
    passiveCols: PropTypes.arrayOf(PropTypes.number),
    corrResponse: PropTypes.shape({
      cm: PropTypes.instanceOf(Object)
    })
  }),
  chartView: PropTypes.arrayOf(PropTypes.number),
  minReqiureModal: PropTypes.bool,
};

export default CorrLeftContentGrid;
